<template>
    <v-navigation-drawer v-model="drawerController" class="pl-5 pr-5 pt-10" width="300" height="100vh" style="position:fixed;z-index:100" color="accent" dark absolute temporary>
        <v-img
              alt="Vuetify Logo"
              class="align-center"
              contain
              width="60"
              src="@/assets/Global/images/barLogo.png"
              transition="scale-transition"
            />
            <h1 style="font-size:30px;">
              <span class="dt-orange__text">Hey 👋 </span>
              <span class="white--text" v-if="$store.state.userDetails.profile.firstname" style="opacity:0.5"> {{ $store.state.userDetails.profile.firstname }} </span>
              <span class="white--text" v-else style="opacity:0.5"> Anonymous </span>
            </h1>
        <v-list class="pt-5" nav dense>
            <v-list-item-group
                v-model="group"
                active-class="white black--text"
            >
                <v-list-item class="mb-5" :to="item.to" link v-for="item in permittedNavs" :key="item.title">
                    <v-list-item-icon>
                        <v-icon> {{item.icon}} </v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{item.title}}</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
// import * as ROUTES from "@/http/routes.js";
import Navigations from "@/http/navigations.js"

export default {
    data : () => ({
        group:'',
        items: [],

    }),
    props:{
        drawer:{
            type:Boolean
        }
    },
    mounted(){
        this.items = Navigations;
    },
    computed:{
        permittedNavs : function (){
            return this.items.filter(item => this.can(item.permissions[0]))
        },
        drawerController:{
            get(){
                return this.drawer
            },
            set(val){
                if(val == false){
                    this.$emit('closeDrawer')
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>